<template>
    <ul style="display: block" :class="ul_class" v-if="categories.length > 0">
        <li  v-for="categ in this.categories" class="mb-2">
            <a v-on:click.stop.prevent="set_active(categ)" href="#" class="p-1" :class="{'bg-primary' : !categ.is_selected,'bg-success': categ.is_selected}">
                <div class="input-group-append border-0"  >
                    <div class="input-group-text border-0" :class="{'bg-primary' : !categ.is_selected,'bg-success': categ.is_selected}">
                        <div class="custom-control custom-checkbox ">
                            <input type="checkbox" v-model="categ.is_selected" class="custom-control-input" 	:id="'cat_' + categ.id">
                            <label class="custom-control-label" :for="'cat_' + categ.id"></label>
                        </div>
                    </div>
                </div>

                <span class="ml-5 nav-link-text">
					{{categ.title}}
				</span>

                <strong class="dl-ref bg-primary-500">
                    {{categ.uniq_id}}
                </strong>

                <b class="collapse-sign pr-3 color-white" v-on:click.stop.prevent="set_active_default(categ)" v-if="with_default">
                    <div>
                        <i class=" fa-star fs-xxl" :class="{'color-white fal' : !categ.is_selected_main,'color-warning-800 fas': categ.is_selected_main}"></i>
                    </div>
                </b>
                <!--
                <b class="collapse-sign pr-3 text-white" v-if="categ.children.length > 0" v-on:click.stop.prevent="show_children(categ)">
                    <em class="fal fa-angle-up"></em>
                </b>
                -->
            </a>

            <categ_node_template
                :with_default="with_default"
                v-if="!is_over_depth"
                :max_depth="max_depth"
                @set_active="set_active"
                @set_active_default="set_active_default"
                :iter_depth="iter_depth + 1" :categories="categ.children">
            </categ_node_template>
        </li>
    </ul>

</template>

<script>
    export default {
        name: "categ_node_template",
        props : {
            categories : Array,
            iter_depth : {
                type : Number,
                default : 0
            },

            with_default : {
                type:Boolean,
                default: true
            },

            max_depth : {
                type : Number,
                default : 2,
            },

            view : {
                type : String,
                default : "categories",
            }
        },
        data() {
            return  {
                cur_depth : 0,
            }
        },
        mounted () {

        },

        methods : {
            show_children (categ) {
                this.$emit("show_children",categ);
            },

            set_active(categ) {
                this.$emit("set_active",categ);
            },
            set_active_default(categ) {
                this.$emit("set_active_default",categ);
            }
        },

        computed : {
            is_over_depth() {
                return parseInt(this.human_depth) > (parseInt(this.max_depth));
            },

            human_depth() {
                return parseInt(this.iter_depth) + 1;
            },

            ul_class() {
               if(this.iter_depth === 0) {
                   return "nav-menu nav-menu-rese nav-categ  mb-sm-4 mb-md-0";
               }

               let child_class = "pl-4";
               if(this.iter_depth > 1) {
                   child_class = child_class + " ml-4 deep_child";
               }

               return child_class;
            }
        },

    }

</script>

<style scoped>
    .deep_child {
        background-color: rgb(229 229 229);
    }
</style>
